import type {ReactElement} from 'react';
import React from 'react';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';

interface ReplaceMediaControlsProps {
  id?: string;
  className?: string;

  onClick(option: ReplaceMediaControlsButtons): void;
}

export enum ReplaceMediaControlsButtons {
  EXPLORE_MEDIA = 'explore-media-option',
  MY_UPLOADS = 'my-uploads-option',
}

export function ReplaceMediaControls({id = '', className = '', ...props}: ReplaceMediaControlsProps): ReactElement<any> {
  const getItems = (): ControlledListItemType[] => {
    return [
      {
        id: ReplaceMediaControlsButtons.MY_UPLOADS,
        text: window.i18next.t('pmwjs_uploads'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-upload',
        onClick: (): void => {
          props.onClick(ReplaceMediaControlsButtons.MY_UPLOADS);
        },
      },
      {
        id: ReplaceMediaControlsButtons.EXPLORE_MEDIA,
        text: window.i18next.t('pmwjs_media'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-media',
        onClick: (): void => {
          props.onClick(ReplaceMediaControlsButtons.EXPLORE_MEDIA);
        },
      },
    ];
  };

  return <ControlledList className={`spacing-m-0 ${className}`} items={getItems()} />;
}
